import { onTopBarHidden, onTopBarVisible } from '@va/dashboard/util-helpers/ui';
import { useWindowDimensions } from '@va/util/hooks';
import { isTopBarHidden } from 'aaas/selectors/appSelectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const useTopBarVisibility = () => {
  const hideTopBar = useSelector(isTopBarHidden);

  const { isTablet } = useWindowDimensions();

  useEffect(() => {
    if (!hideTopBar) return;
    if (isTablet) {
      onTopBarVisible();
    } else {
      onTopBarHidden();
    }
  }, [hideTopBar, isTablet]);

  return {};
};

export default useTopBarVisibility;
